import { createFileRoute, redirect } from '@tanstack/react-router';
import { ExtensionsPage } from '../pages/ExtensionsPage';
import { useAuthStore } from '../stores/auth-store';

export const Route = createFileRoute('/extensions' as any)({
  component: ExtensionsPage,
  beforeLoad: () => {
    if (!useAuthStore.getState().isAuthenticated) {
      throw redirect({ to: '/login' });
    }
  },
});
